// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"2037":"880fa4322f150914bea9","5024":"2aab39af3910d2065e9e","5677":"7ba1d173c58172ce6b99","7227":"95b8ae576d3670af31a9"}[chunkId] + ".js?v=" + {"2037":"880fa4322f150914bea9","5024":"2aab39af3910d2065e9e","5677":"7ba1d173c58172ce6b99","7227":"95b8ae576d3670af31a9"}[chunkId] + "";
};